module.exports = __webpack_public_path__ + "img/popov.ee27c39f.jpg";